module.exports = __webpack_public_path__ + "media/images/doctor-logo-e7badf0a722adfd65ae38704efb00184.png";